import React, {useState} from "react";
import "./contactus.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp,faWeixin,faFacebook,faInstagram,faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faLocation, faPhone } from "@fortawesome/free-solid-svg-icons";
import Footernav from "./Component/footernav";
function ContactUs() {
  const [resul, setResul] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "e913b0cc-f413-4385-bc0b-74f2007887c6");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setResul(true);
      event.target.reset();
    } else {
      alert("Error Please Resubmit This Form !")
    }
  };
  return (
    <main>
      <div className="chitto">
        <div className="banner-contact">
          <img src="/img/company/contactus.jpg" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>Contact Us</h1>
        <p>We’re here to help you plan your perfect trip</p>
      </div>
      </div>
      </div>
      {/* HEADER */}
      <div className="contactus-container">
      

      {/* MAIN SECTION */}
      <div className="contactus-main">

        {/* LEFT - CONTACT FORM */}
        <div className="contactus-form-section">
          <h2>Send Us a Message</h2>

          <form className="contactus-form" onSubmit={onSubmit}>
            <input type="text" placeholder="Full Name" name="Name" />
            <input type="email" placeholder="Mail Address" required name="Mail" />
            <input type="tel" placeholder="Phone Number (Optional)" name="Number" />
            <select name="Services">
              <option>Select Service</option>
              <option>Nepal Tour</option>
              <option>Hotel Booking</option>
              <option>Guide Service</option>
              <option>Vehicle Rental</option>
            </select>
            <textarea placeholder="Your Message" name="Message"></textarea>

            <button type="submit">Send Message</button>
           
          </form>
          
        </div>
        <div>
 {resul &&( 
  <div className='booking-lresult'>
    <div className="booking-container">
      {/* Top Navigation */}
      <div className="booking-top-nav">
        <button className="booking-back-btn" onClick={()=>setResul(false)}>
          <span className="booking-arrow">&lt;</span> Back To Page
        </button>
      </div>

      {/* Main Content Area */}
      <div className="booking-main-content">
        
        {/* Success Header Status */}
        <div className="booking-status-header">
          <div className="booking-success-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" className="booking-svg-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="booking-status-title">Enquiry Send</h1>
          <p className="booking-status-subtitle">
           "You have successfully Send your Enquiry"
          </p>
        </div>

        {/* Receipt Wrapper Card */}
        <div className="booking-receipt-card">
          
          {/* Plan Header Segment */}
          <div className="booking-plan-badge-container">
            <div className="booking-plan-info">
              <span className="booking-crown-emoji">👑</span>
              <div>
                <h3 className="booking-plan-title">
                  Contact
                  
                </h3>
                <p className="booking-plan-dates"> Your designated Trip Expert will contact you soon.</p>
              </div>
            </div>
          </div>

          {/* Important Procedural Notice */}
          <div className="booking-notice-box">
            <p>
              <strong>Important:</strong> All Your quiries are solve by your designated trip expert and after all things okay and want to book services you can book directly with trip expert through message and Please follow all the payment procedure strictly with your designated trip expert only who contact you from one of the listed medium below. He is always available throughout the trip if any problems arise. And Contact with him only from listed medium not through any other medium which is not listed below.
            </p>
          </div>
          {/* Designated Trip Expert Footer Segment (Normal HTML) */}
          <div className="booking-receipt-footer">
            <div className="booking-expert-profile-info">
              <div className="booking-expert-avatar-container">
                <img 
                  src="/img/company/destination expert.png" 
                  alt="Mr. Bishnu Pandey" 
                  className="booking-expert-photo"
                />
              </div>
              <div>
                <span className="booking-expert-badge">Designated Trip Expert</span>
                <h4 className="booking-expert-name">Mr. Bishnu Pandey</h4>
                <p className="booking-expert-availability">● Always Available</p>
                <div className="contact-boo">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-boo">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-boo">
            <FontAwesomeIcon icon={faEnvelope} className="icon effect" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
              </div>
            </div>

           
          </div>

        </div>

        {/* Cancel State Action Button */}

      </div>
    </div>
  </div>
)}
 </div>
        {/* RIGHT - CONTACT INFO */}
        <div className="contactus-info-section">

          <h2>Contact Information</h2>

          <div className="contactus-info-box">
            <p><FontAwesomeIcon icon={faLocation} className="icon" />(Location) :  Kathmandu, Nepal</p>
            <p><FontAwesomeIcon icon={faPhone} className="icon" />(Phone) : +977-9863841456</p>
            <p><FontAwesomeIcon icon={faEnvelope} className="icon" />(Gmail) : 012shy1234@gmail.com</p>
            <p><FontAwesomeIcon icon={faWhatsapp} className="icon effect" />(WhatsApp) : 9863841456</p>
            <p><FontAwesomeIcon icon={faWeixin} className="icon effect" />(Wechat ID) : Bishnu Pandey</p>
          </div>

          {/* BUSINESS HOURS */}
          <div className="contactus-hours">
            <h3>Business Hours</h3>
            <p>Sunday - Friday: 9:00 AM - 7:00 PM</p>
            <p>Saturday: Closed</p>
          </div>

          {/* SOCIAL MEDIA */}
          <div className="social">
        <p>Follow us on social media</p>
        <div className="socialicons">
          <Link to="https://www.facebook.com/profile.php?id=61590545644233" target="_blank"><FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon></Link>
          <Link to="https://www.instagram.com/himalayastravelsofficial/" target="_blank"><FontAwesomeIcon icon={faInstagram}></FontAwesomeIcon></Link>
          <Link to="https://www.youtube.com/channel/UCj-bEPS5hTJ-vcvdWlH6Cbg" target="_blank"><FontAwesomeIcon icon={faYoutube}></FontAwesomeIcon></Link>
          <Link to="https://www.tiktok.com/@himalayastravelsofficial" target="_blank"><FontAwesomeIcon icon={faTiktok}></FontAwesomeIcon></Link>
        </div>
        </div>

        </div>
      </div>

      {/* MAP SECTION */}
      <div className="contactus-map">
        <h2>Our Office Location</h2>
       <iframe className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3531.006345162988!2d85.29679076845517!3d27.74795029415453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb194918041995%3A0x2290f0e48f50d549!2sUjalo%20Basthi%20Lolang%20height!5e0!3m2!1sne!2snp!4v1736396520103!5m2!1sne!2snp" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

      {/* EXTRA CTA */}
      {/* FAQ */}
      {/* <div className="contactus-faq">
        <h2>Quick Questions</h2>
        <div className="contactus-faq-item">
          <h4>How fast do you respond?</h4>
          <p>Usually within 5–10 minutes during business hours.</p>
        </div>
        <div className="contactus-faq-item">
          <h4>Can I customize my trip?</h4>
          <p>Yes, we provide fully customizable travel packages.</p>
        </div>
      </div> */}
   </div>
   <Footernav/>
    </main>
  );
}

export default ContactUs;